export default "__VITE_ASSET__ZZZSM$S2__"